<!--<div class="card-with-shadow bg-white p-2">
  <div class="text-lg font-bold">Drivers On Shift Next 48hrs ({{ earningsPerDay?.name }})</div>
  <div *ngIf="subtext" class="{{ subtext.classes }}">{{ subtext.content }}</div>
  <div></div>
  <div [chart]="chart" class=""></div>
</div>


<div *ngIf="belowCommitment > 0" class="card-with-shadow bg-white p-2 mt-2">
  <div class="text-lg font-bold mb-1">Capacity Action Items</div>
  <div class="grid grid-cols-4 gap-2">
    <ng-container *ngFor="let earnings of clonedEarnings; trackBy: 'id' | trackByKey">
      <div class="flex flex-row items-center" *ngIf="earnings.belowCommitment">
        <div class="bg-red-500 text-white h-4 w-4 p-2 rounded-full flex items-center justify-center mr-2">{{ earnings.belowCommitment.index }}</div>
        <div>{{ earnings.belowCommitment.message + (earnings.belowCommitment.timestamp | standardDate) }}</div>
      </div>
    </ng-container>
  </div>
</div>-->

<div class="flex flex-row">
  <div class="card-with-shadow bg-white p-2 w-2/3" [class.w-full]="belowCommitment === 0">
    <div class="text-lg font-bold">Drivers On Shift Next 48hrs ({{ earningsPerDay?.name }})</div>
    <div *ngIf="subtext" class="{{ subtext.classes }}">{{ subtext.content }}</div>
    <div></div>
    <div [chart]="chart" class=""></div>
  </div>

  <div *ngIf="belowCommitment > 0" class="card-with-shadow bg-white p-2 w-1/3 ml-2">
    <div class="text-lg font-bold mb-2">Capacity Action Items</div>
    <div class="grid grid-cols-1 gap-2">
      <ng-container *ngFor="let earnings of clonedEarnings; trackBy: 'id' | trackByKey">
        <div
          class="flex flex-row items-center cursor-pointer"
          *ngIf="earnings.belowCommitment"
          (click)="emitDateString(earnings.belowCommitment.timestamp)"
        >
          <div class="bg-red-500 text-white h-4 w-4 p-2 rounded-full flex items-center justify-center mr-2">
            {{ earnings.belowCommitment.index }}
          </div>
          <div>{{ earnings.belowCommitment.message + (earnings.belowCommitment.timestamp | standardDate) }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
